import { render, staticRenderFns } from "./AlipayResult.vue?vue&type=template&id=d5e01df4"
import script from "./AlipayResult.vue?vue&type=script&lang=js"
export * from "./AlipayResult.vue?vue&type=script&lang=js"
import style0 from "./AlipayResult.vue?vue&type=style&index=0&id=d5e01df4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports